import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrder } from "interfaces/SortOrder";

const base = "WORKOUTS_PAGE";
export const SET_SHOULD_SCROLL_SYNC = `${base}_SET_SHOULD_SCROLL_SYNC`;
export const SET_IS_CONDENSED_VIEW = `${base}_SET_IS_CONDENSED_VIEW`;
export const SET_SCHEDULED_DATES_ONLY = `${base}_SET_SCHEDULED_DATES_ONLY`;
export const SET_HORSE_NAME = `${base}_SET_HORSE_NAME`;
export const SET_SELECTED_FACILITY = `${base}_SET_SELECTED_FACILITY`;
export const SET_PAGE = `${base}_SET_PAGE`;
export const SET_SHOW_WEATHER = `${base}_SET_SHOW_WEATHER`;
export const SET_WEATHER_HEIGHT = `${base}_SET_WEATHER_HEIGHT`;
export const SET_SELECTED_HORSE_ID = `${base}_SET_SELECTED_HORSE_ID`;
export const SET_SORT_ORDER = `${base}_SET_SORT_ORDER`;
export const SET_SEARCH_VALUE = `${base}_SET_SEARCH_VALUE`;

export interface WorkoutsPageType {
  type: string;
  shouldScrollSync: boolean;
  scheduledDatesOnly: boolean;
  isCondensedView: boolean;
  horseName: string;
  selectedFacility: racehorse360.IFacility;
  selectedHorseId: string;
  page: number;
  showWeather: boolean;
  weatherHeight: number;
  sortOrder: SortOrder;
  searchValue?: string;
}

export const setShouldScrollSync = (
  shouldScrollSync: boolean
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SHOULD_SCROLL_SYNC,
    shouldScrollSync
  };
};
export const setScheduledDatesOnly = (
  scheduledDatesOnly: boolean
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SCHEDULED_DATES_ONLY,
    scheduledDatesOnly
  };
};
export const setIsCondensedView = (
  isCondensedView: boolean
): Partial<WorkoutsPageType> => {
  return {
    type: SET_IS_CONDENSED_VIEW,
    isCondensedView
  };
};
export const setHorseName = (horseName: string): Partial<WorkoutsPageType> => {
  return {
    type: SET_HORSE_NAME,
    horseName
  };
};
export const setSelectedFacility = (
  selectedFacility: racehorse360.IFacility
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SELECTED_FACILITY,
    selectedFacility
  };
};
export const setSelectedHorseId = (
  selectedHorseId: string
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SELECTED_HORSE_ID,
    selectedHorseId
  };
};
export const setPage = (page: number): Partial<WorkoutsPageType> => {
  return {
    type: SET_PAGE,
    page
  };
};
export const setShowWeather = (
  showWeather: boolean
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SHOW_WEATHER,
    showWeather
  };
};
export const setWeatherHeight = (
  weatherHeight: number
): Partial<WorkoutsPageType> => {
  return {
    type: SET_WEATHER_HEIGHT,
    weatherHeight
  };
};
export const setSortOrder = (
  sortOrder: SortOrder
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SORT_ORDER,
    sortOrder
  };
};
export const setSearchValue = (
  searchValue: string
): Partial<WorkoutsPageType> => {
  return {
    type: SET_SEARCH_VALUE,
    searchValue
  };
};
